'use strict';

/**
 * Project-financials card from tool digest cents. Never parse prose.
 * Card only when digest.kind === 'project_financials'.
 */

import { escapeHtml } from './sorenAnswerMarkdown.js';

function moneyText(m) {
  if (m && typeof m.formatted === 'string' && m.formatted) return m.formatted;
  if (m && m.amount != null) {
    const n = Number(m.amount);
    if (!Number.isFinite(n)) return '—';
    return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return '—';
}

function pickMoney(row, key) {
  return (row && row[key]) || null;
}

function modelFromRow(row, fallback) {
  const src = row || {};
  const fb = fallback || {};
  const pid = src.project_id != null ? src.project_id : fb.project_id;
  const routes = src.routes || fb.routes || {};
  const href = routes.outstanding
    || (pid != null ? `/projects?pm=${pid}&hl=outstanding` : null);
  return {
    title: src.project_name || fb.project_name || 'Project',
    outstanding: moneyText(pickMoney(src, 'outstanding') || pickMoney(fb, 'outstanding')),
    left_to_bill: moneyText(pickMoney(src, 'left_to_bill') || pickMoney(fb, 'left_to_bill')),
    received: moneyText(pickMoney(src, 'received') || pickMoney(fb, 'received')),
    retainage: moneyText(pickMoney(src, 'retainage') || pickMoney(fb, 'retainage')),
    href,
  };
}

function projectFinancialsCardModels(digest) {
  if (!digest || digest.kind !== 'project_financials') return [];
  const rows = Array.isArray(digest.projects) && digest.projects.length
    ? digest.projects
    : [digest];
  return rows.map((row) => modelFromRow(row, digest));
}

function projectFinancialsCardModel(digest) {
  return projectFinancialsCardModels(digest)[0] || null;
}

function cardHtmlFromModel(model) {
  const btn = model.href
    ? `<a class="cr-btn dark" data-testid="soren-open-project" href="${escapeHtml(model.href)}">Open project</a>`
    : '';
  return `<div class="soren-project-financials" data-testid="soren-project-financials">
  <h3 data-testid="soren-pf-title">${escapeHtml(model.title)}</h3>
  <ul class="soren-fact-list">
    <li data-testid="soren-pf-outstanding"><span>Outstanding</span><strong>${escapeHtml(model.outstanding)}</strong></li>
    <li data-testid="soren-pf-left-to-bill"><span>Left to bill</span><strong>${escapeHtml(model.left_to_bill)}</strong></li>
    <li data-testid="soren-pf-received"><span>Received</span><strong>${escapeHtml(model.received)}</strong></li>
    <li data-testid="soren-pf-retainage"><span>Retainage</span><strong>${escapeHtml(model.retainage)}</strong></li>
  </ul>
  ${btn}
</div>`;
}

function projectFinancialsCardHtml(digest) {
  return projectFinancialsCardModels(digest).map(cardHtmlFromModel).join('');
}

export {
  moneyText,
  projectFinancialsCardModel,
  projectFinancialsCardModels,
  projectFinancialsCardHtml,
};
